'use strict';
angular.module('appMarketplace')
    .service('BasketService', ['$http', 'UrlService', 'NavigationService',
        function ($http, UrlService, NavigationService) {
            var service = this;
            var basketUrl = UrlService.createAbsoluteUrl('/rest/basket');

            function basketItemMapper(basketItem) {
                return {
                    id: basketItem.id,
                    vendorId: basketItem.vendorId,
                    catalogueId: basketItem.catalogueId,
                    itemCode: basketItem.itemCode,
                    description: basketItem.description,
                    supplierPartAuxiliaryId: basketItem.supplierPartAuxiliaryId
                };
            }

            function getUrl(page, basketId, param) {
                var url = basketUrl;
                url += (page === 'SavedBaskets') ? '/saved/' : '/queue/';
                url += basketId;
                if (param) url += param;
                return url;
            }

            service.getCurrentBasket = function (successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getCurrentBasketVat = function (successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/vats')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getCurrentBasketWithValidatedCategories = function (successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current'),
                    params: {
                        validateCategories: true
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.addItemToBasket = function (item, successCallback, errorCallback, options) {
                service.addItemsToBasket([item], successCallback, errorCallback, options);
            };

            service.addItemsToBasket = function (items, successCallback, errorCallback, options) {
                options = options || {};
                var data = [];
                angular.forEach(items, function iterator(item) {
                    data.push({
                        id: item.id,
                        quantity: item.quantity,
                        clin: item.clin,
                        catalogueId: item.catalogueId,
                        vendorId: item.vendorId,
                        fieldId: item.fieldId
                    });
                });
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/items'),
                    data: {
                        products: data,
                        returnBasket: options.returnBasket
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    var basketActionResult = response.data;
                    NavigationService.updateBasketBadge(basketActionResult.currentBasketSize, basketActionResult.basketNetTotal.value);
                    successCallback(basketActionResult);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.removeBasketItem = function (basketItem, successCallback, errorCallback) {
                return service.removeBasketItems([basketItem], successCallback, errorCallback);
            };

            service.removeBasketItems = function (basketItems, successCallback, errorCallback) {
                var data = basketItems.map(basketItemMapper);
                var req = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/items'),
                    data: data
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.commentOnBasketItem = function (itemId, comments, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/items/' + itemId + '/comments'),
                    data: comments
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.removeBasketItemAttachment = function (itemId, attachmentId, successCallback, errorCallback) {
                var req = {
                    method: 'DELETE',
                    url: UrlService.createAbsoluteUrl('/rest/basket/items/' + itemId + '/attachments/' + attachmentId)
                };

                return $http(req).then(successCallback, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.addVendorToBasket = function (vendorId, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/vendors/' + vendorId)
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.removeVendorFromBasket = function (vendorId, successCallback, errorCallback) {
                var req = {
                    method: 'DELETE',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/vendors/' + vendorId)
                };

                return $http(req).then(successCallback, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.checkoutBasket = function (items, skipCheckoutAlerts, continueAction, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/checkout'),
                    data: {
                        items: items,
                        skipCheckoutAlerts: skipCheckoutAlerts,
                        continueAction: continueAction
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.updateBasket = function (basketItems, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/update'),
                    data: {
                        items: basketItems
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.emptyBasket = function (successCallback, errorCallback) {
                var req = {
                    method: 'DELETE',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.saveBasket = function (name, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/save'),
                    data: name
                };

                return $http(req).then(successCallback,
                    function errorCallbackWrapper(response) {
                        errorCallback(response.data);
                    });
            };

            service.shareBasket = function (groupId, name, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/share'),
                    data: {
                        groupId: groupId,
                        basketName: name
                    }
                };

                return $http(req).then(successCallback,
                    function errorCallbackWrapper(response) {
                        errorCallback(response.data);
                    });
            };

            service.getAdditionalForms = function (formIds, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/forms/'),
                    params: {
                        formId: formIds
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getAdditionalFormsFromQueueSavedBasket = function (page, basketId, formIds, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: getUrl(page, basketId, '/forms'),
                    params: {
                        formId: formIds
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.saveAdditionalForm = function (form, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/forms/' + form.currentAdditionalInformationFormId),
                    data: form.currentCatalogueRequestFormData
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.saveAdditionalFormForQueueSavedBasket = function (page, basketId, form, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/forms/') + form.currentAdditionalInformationFormId,
                    data: form.currentCatalogueRequestFormData
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.bulkUpdateVat = function (vatCodeV, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/bulkUpdateVat'),
                    data: vatCodeV
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.groupBasketItems = function (basket) {
                return basket.items.reduce(function iterator(acc, item) {
                    var vendorCatalogueOnly = false;
                    var name = item.vendorName;
                    var group = item.fromCatalogue ? 'catalogue' : 'nonCatalogue';
                    if (basket.vendorsSettings[item.vendorId] != null) {
                        vendorCatalogueOnly = basket.vendorsSettings[item.vendorId].catalogueOnly;
                    }
                    acc[name] = acc[name] ||
                        {
                            vendorId: item.vendorId,
                            businessName: item.vendorName,
                            catalogueOnly: vendorCatalogueOnly ? vendorCatalogueOnly : false,
                            currency: {
                                currencyCode: item.currency.currencyCode,
                                currencySymbol: item.currency.currencySymbol
                            }
                        };
                    acc[name][group] = acc[name][group] || [];
                    acc[name][group].push(item);
                    return acc;
                }, {});
            };

            service.getSavedBaskets = function (params, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/saved'),
                    params: params
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.deleteBasket = function (basketId, page, successCallback, errorCallback) {
                var req = {
                    method: 'DELETE',
                    url: getUrl(page, basketId, null)
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.deleteOutdatedBasketItems = function (basketId, page, successCallback, errorCallback) {
                var req = {
                    method: 'DELETE',
                    url: getUrl(page, basketId, '/outdatedItems')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.loadBasket = function (basketId, page, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/load')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.addToCurrentBasket = function (basketId, page, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/addToCurrent')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.changeBasketGroup = function (basketId, oldBasketGroupId, newBasketGroupId, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/saved/' + basketId + '/group'),
                    data: {
                        oldGroupId: oldBasketGroupId,
                        newGroupId: newBasketGroupId
                    }
                };

                return $http(req).then(successCallback, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.updateHistoryQueueBasket = function (page, basketId, items, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/update'),
                    data: {
                        items: items
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getSavedBasket = function (basketId, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/saved/' + basketId)
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getQueueBasket = function (basketId, successCallBack, errorCallBack) {
                var req = {
                    method: 'GET',
                    url: basketUrl + '/queue/' + basketId
                };

                return $http(req).then(function successCallBackWrapper(response) {
                    successCallBack(response.data);
                }, function errorCallBackWrapper(response) {
                    errorCallBack(response.data);
                })
            };

            service.getBasketVat = function (basketId, page, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: getUrl(page, basketId, '/vats')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getHistoryQueueBasketWithValidatedCategories = function (page, basketId, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: getUrl(page, basketId, null),
                    validateCategories: true
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.saveSharedBasket = function (basket, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/saved/' + basket.id + '/save'),
                    data: basket
                };

                return $http(req).then(successCallback, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.getBasketSettings = function (successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/settings')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.removeHistoryQueueBasketItems = function (page, basketId, basketItems, successCallback, errorCallback) {
                var data = basketItems.map(basketItemMapper);
                var req = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    url: getUrl(page, basketId, '/items'),
                    data: data
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.checkoutQueueSavedBasket = function (page, basketId, items, skipCheckoutAlerts, continueAction, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/checkout'),
                    data: {
                        items: items,
                        skipCheckoutAlerts: skipCheckoutAlerts,
                        continueAction: continueAction
                    }
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.applyCodeForCurrentBasket = function (itemId, unspsc, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/items/' + itemId + '/unspsc/' + unspsc),
                    data: unspsc
                };

                $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.applyCodeForVendorForCurrentBasket = function (vendorId, unspsc, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/vendors/' + vendorId + '/unspsc/' + unspsc),
                    data: unspsc
                };

                $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.applyCodeForHistoryQueueBasket = function (page, basketId, itemId, unspsc, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/items/') + itemId + '/unspsc/' + unspsc,
                    data: unspsc
                };

                $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.applyCodeForVendorForHistoryQueueBasket = function (page, basketId, vendorId, unspsc, successCallback, errorCallback) {
                var req = {
                    method: 'POST',
                    url: getUrl(page, basketId, '/vendors/') + vendorId + '/unspsc/' + unspsc,
                    data: unspsc
                };

                $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };

            service.openBasket = function (basketId, page) {
                var url = UrlService.createAbsoluteUrl('/page/basket.html');
                if (basketId) {
                    url += '?id=' + basketId + '&page=' + page;
                }
                window.location.href = url;
            };

            service.getContractsForCurrentBasket = function (successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/current/contracts'),
                    cache: true
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };


            service.getContractsForBasket = function (basketId, page, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: getUrl(page, basketId, '/contracts')
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response.data);
                });
            };


            service.getSavedBasketItems = function (basketId, canceller, successCallback, errorCallback) {
                var req = {
                    method: 'GET',
                    url: UrlService.createAbsoluteUrl('/rest/basket/saved/' + basketId + '/items'),
                    timeout: canceller
                };

                return $http(req).then(function successCallbackWrapper(response) {
                    successCallback(response.data);
                }, function errorCallbackWrapper(response) {
                    errorCallback(response);
                });
            };

            service.getSortChoiceMap = function () {
                return {
                    BASKET_DATE_ASC: {
                        field: "BASKET_DATE",
                        direction: "ASC"
                    },
                    BASKET_DATE_DESC: {
                        field: "BASKET_DATE",
                        direction: "DESC"
                    },
                    BASKET_NAME_ASC: {
                        field: "BASKET_NAME",
                        direction: "ASC"
                    },
                    BASKET_NAME_DESC: {
                        field: "BASKET_NAME",
                        direction: "DESC"
                    }
                };
            }
        }]);



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/basket-service.js
// module id = 266
// module chunks = 37